var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({},'v-select',_vm.computedProps,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }